module.exports = __webpack_public_path__ + "static/media/btn_industria.fda5f3c1.png";